module.exports = "https://cdn.hellotech.com/client-assets/tech-client-speaker-tablet_4f37cde1c7209a4cfef6f621907b9879.webp";